module.exports = __webpack_public_path__ + "static/media/400382_02.e30ac6c3.png";